var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l([], function(item) {
        return _c("el-option", {
          key: item.value,
          attrs: {
            label: item.label,
            multiple: "",
            "collapse-tags": "",
            value: item.value
          }
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "custom-tree__box",
          attrs: { slot: "empty" },
          slot: "empty"
        },
        [
          _c(
            "el-input",
            {
              staticClass: "custom-tree__search",
              attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
              on: { input: _vm.inputChange },
              model: {
                value: _vm.filterText,
                callback: function($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText"
              }
            },
            [_c("el-button", { attrs: { slot: "prepend" }, slot: "prepend" })],
            1
          ),
          _vm._v(" "),
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.effectiveData,
              "show-checkbox": false,
              "default-expand-all": "",
              "node-key": _vm.props.id || "id",
              indent: 8,
              "expand-on-click-node": false,
              "highlight-current": "",
              "check-strictly": _vm.checkStrictly,
              "filter-node-method": _vm.filterNode,
              props: _vm.props
            },
            on: { "node-click": _vm.nodeClick }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404e29be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404e29be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationTree.vue
// module id = null
// module chunks = 